#import "../fragments/newsletter-stub-fragment.graphql"

mutation UpdateNewsletter($newsletter: CampaignUpdateInput!) {
    campaignUpdate(input: $newsletter) {
        campaign {
            ...NewsletterStubFragment
        }
    }
}
